import React from "react";

const TableService = (props) => {
  const { serviceType, serviceHandler, selected } = props;

  return (
    <table className="table table-centered table-nowrap mb-0">
      <thead>
        <tr>
          <th>Service</th>
          <th>Port Delivery</th>
          <th>Door Delivery</th>
        </tr>
      </thead>

      <tbody>

        {
          serviceType &&
            (serviceType.courier_port_delivery !== "Not Applicable" || serviceType.courier_door_delivery !== "Not Applicable") ? (
            <tr>
              <td>Courier Freight</td>
              <td>
                {serviceType &&
                  serviceType &&
                  serviceType.courier_port_delivery === "Not Applicable" ? (
                  "Not Applicable"
                ) : (
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="servicetype"
                      id="courierport"
                      onClick={(e) =>
                        serviceHandler(
                          e,
                          "PORTCOURIER",
                          serviceType && serviceType.courier_port_delivery
                        )
                      }
                      checked={selected === "PORTCOURIER" ? true : false}
                      value="PORTCOURIER"
                    />
                    <label class="form-check-label" htmlFor="courierport">
                      AED {serviceType && serviceType.courier_port_delivery}
                    </label>
                  </div>
                )}
              </td>
              <td>
                {serviceType &&
                  serviceType.courier_door_delivery === "Not Applicable" ? (
                  "Not Applicable"
                ) : (
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="servicetype"
                      id="courierdoor"
                      value="DOORCOURIER"
                      checked={selected === "DOORCOURIER" ? true : false}
                      onClick={(e) =>
                        serviceHandler(
                          e,
                          "DOORCOURIER",
                          serviceType && serviceType.courier_door_delivery
                        )
                      }
                    />
                    <label class="form-check-label" htmlFor="courierdoor">
                      AED {serviceType && serviceType.courier_door_delivery}
                    </label>
                  </div>
                )}
              </td>
            </tr>
          )
            : ""
        }

        {
          serviceType &&
            (serviceType.air_port_delivery !== "Not Applicable" || serviceType.air_door_delivery !== "Not Applicable" || serviceType.air_consolidation_delivery !== "Not Applicable") ?
            <tr>
              <td>Air Freight</td>
              <td>
                {serviceType &&
                  serviceType.air_port_delivery === "Not Applicable" ? (
                  "Not Applicable"
                ) : (
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="servicetype"
                      id="airport"
                      checked={selected === "PORTAIR" ? true : false}
                      value="PORTAIR"
                      onClick={(e) =>
                        serviceHandler(
                          e,
                          "PORTAIR",
                          serviceType && serviceType.air_port_delivery
                        )
                      }
                    />
                    <label class="form-check-label" htmlFor="airport">
                      AED {serviceType && serviceType.air_port_delivery}
                    </label>
                  </div>
                )}
              </td>
              <td>
                {serviceType &&
                  serviceType.air_consolidation_delivery === "Not Applicable" &&
                  serviceType.air_door_delivery === "Not Applicable" ? (
                  "Not Applicable"
                ) : (
                  <>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="servicetype"
                        id="airdoor"
                        checked={selected === "DOORAIR" ? true : false}
                        value="DOORAIR"
                        onClick={(e) =>
                          serviceHandler(
                            e,
                            "DOORAIR",
                            serviceType && serviceType.air_door_delivery
                          )
                        }
                      />
                      <label class="form-check-label" htmlFor="airdoor">
                        AED {serviceType && serviceType.air_door_delivery}
                      </label>
                    </div>

                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="servicetype"
                        id="airconsolidation"
                        value="CONSOLIDATIONAIR"
                        checked={selected === "CONSOLIDATIONAIR" ? true : false}
                        onClick={(e) =>
                          serviceHandler(
                            e,
                            "CONSOLIDATIONAIR",
                            serviceType && serviceType.air_consolidation_delivery
                          )
                        }
                      />
                      <label class="form-check-label" htmlFor="airconsolidation">
                        AED
                        {serviceType && serviceType.air_consolidation_delivery}
                        <span className="text-muted">(Consolidation)</span>
                      </label>
                    </div>
                  </>
                )}
              </td>
            </tr>
            : ""
        }

        {
          serviceType &&
            (serviceType.sea_port_delivery !== "Not Applicable" || serviceType.sea_door_delivery !== "Not Applicable" || serviceType.sea_consolidation_delivery !== "Not Applicable") ?
            <tr>
              <td>Sea Freight</td>
              <td>
                {serviceType &&
                  serviceType.sea_port_delivery === "Not Applicable" ? (
                  "Not Applicable"
                ) : (
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="servicetype"
                      id="seaport"
                      checked={selected === "PORTSEA" ? true : false}
                      value="PORTSEA"
                      onClick={(e) =>
                        serviceHandler(
                          e,
                          "PORTSEA",
                          serviceType && serviceType.sea_port_delivery
                        )
                      }
                    />
                    <label class="form-check-label" htmlFor="seaport">
                      AED
                      {serviceType && serviceType.sea_port_delivery}
                    </label>
                  </div>
                )}
              </td>
              <td>
                {serviceType &&
                  serviceType.sea_consolidation_delivery === "Not Applicable" &&
                  serviceType.sea_door_delivery === "Not Applicable" ? (
                  "Not Applicable"
                ) : (
                  <>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="servicetype"
                        id="seadoor"
                        checked={selected === "DOORSEA" ? true : false}
                        value="DOORSEA"
                        onClick={(e) =>
                          serviceHandler(
                            e,
                            "DOORSEA",
                            serviceType && serviceType.sea_door_delivery
                          )
                        }
                      />
                      <label class="form-check-label" htmlFor="seadoor">
                        AED {serviceType && serviceType.sea_door_delivery}
                      </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="servicetype"
                        id="seaconsolidation"
                        value="CONSOLIDATIONSEA"
                        checked={selected === "CONSOLIDATIONSEA" ? true : false}
                        onClick={(e) =>
                          serviceHandler(
                            e,
                            "CONSOLIDATIONSEA",
                            serviceType && serviceType.sea_consolidation_delivery
                          )
                        }
                      />
                      <label class="form-check-label" htmlFor="seaconsolidation">
                        AED
                        {serviceType && serviceType.sea_consolidation_delivery}
                        <span className="text-muted">(Consolidation)</span>
                      </label>
                    </div>
                  </>
                )}
              </td>
            </tr>
            : ""
        }


        {
          serviceType &&
            (serviceType.land_port_delivery !== "Not Applicable" || serviceType.land_door_delivery !== "Not Applicable" || serviceType.land_consolidation_delivery !== "Not Applicable") ?
            <tr>
              <td>Road Freight</td>
              <td>
                {serviceType &&
                  serviceType.land_port_delivery === "Not Applicable" ? (
                  "Not Applicable"
                ) : (
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="servicetype"
                      id="roadport"
                      checked={selected === "PORTLAND" ? true : false}
                      onClick={(e) =>
                        serviceHandler(
                          e,
                          "PORTLAND",
                          serviceType && serviceType.land_port_delivery
                        )
                      }
                      value="PORTLAND"
                    />
                    <label class="form-check-label" htmlFor="roadport">
                      AED {serviceType && serviceType.land_port_delivery}
                    </label>
                  </div>
                )}
              </td>
              <td>
                {serviceType &&
                  serviceType.land_consolidation_delivery === "Not Applicable" &&
                  serviceType.land_door_delivery === "Not Applicable" ? (
                  "Not Applicable"
                ) : (
                  <>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="radio"
                        name="servicetype"
                        id="roadland"
                        checked={selected === "DOORLAND" ? true : false}
                        onClick={(e) =>
                          serviceHandler(
                            e,
                            "DOORLAND",
                            serviceType && serviceType.land_door_delivery
                          )
                        }
                        value="DOORLAND"
                      />
                      <label class="form-check-label" htmlFor="roadland">
                        AED {serviceType && serviceType.land_door_delivery}
                      </label>
                    </div>
                    <div class="form-check">
                      {
                        serviceType?.land_consolidation_delivery === "Not Applicable" ?
                          "Consolidation Not Applicable"
                          :
                          <>
                            <input
                              class="form-check-input"
                              type="radio"
                              name="servicetype"
                              id="seaconsolidation"
                              value="CONSOLIDATIONSEA"
                              checked={selected === "CONSOLIDATIONROAD" ? true : false}
                              onClick={(e) =>
                                serviceHandler(
                                  e,
                                  "CONSOLIDATIONROAD",
                                  serviceType && serviceType.land_consolidation_delivery
                                )
                              }
                            />
                            <label class="form-check-label" htmlFor="seaconsolidation">
                              AED
                              {serviceType && serviceType.land_consolidation_delivery}
                              <span className="text-muted">(Consolidation)</span>
                            </label>
                          </>
                      }

                    </div>
                  </>
                )}
              </td>
            </tr>
            : ""
        }


      </tbody>
    </table>
  );
};

export default TableService;
